import './Home.css';
import { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';
import Skeleton from './Skeleton';

const Resume = () => {
  const [resumeData, setResumeData] = useState({
    summary: [],
    education: [],
    experience: []
  });
  const [resumeUrl, setResumeUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchResume = async () => {
      try {
        const { data, error } = await supabase
          .from('resume_items')
          .select('*')
          .order('id'); // Assuming order by ID or a specific 'order' column
        
        if (error) throw error;

        if (data) {
            const summary = data.filter(item => item.type === 'summary');
            const education = data.filter(item => item.type === 'education');
            const experience = data.filter(item => item.type === 'experience');
            setResumeData({ summary, education, experience });
        }

        // Fetch resume URL
        const { data: aboutData } = await supabase
          .from('about')
          .select('resume_url')
          .single();
        
        if (aboutData) {
            setResumeUrl(aboutData.resume_url);
        }

      } catch (error) {
        console.error('Error fetching resume data:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchResume();
  }, []);

  // Fallback data
  const defaultData = {
      summary: [{
          title: "Devaprasad",
          description: "I am a 4th-year B.Tech student in the Division of Computer Science at School of Engineering CUSAT.",
          contact_info: {
              address: "Kannur,Kerala",
              phone: "8547198697",
              email: "devaprasadmohan@gmail.com"
          }
      }],
      education: [
          {
              title: "B.Tech",
              subtitle: "2019 - 2023",
              institution: "COCHIN UNIVERSITY OF SCIENCE AND TECHNOLOGY",
              description: "Currently studying for B.tech Computer Science and Engineering.\nExpected to graduate in 2023. Current CGPA :9.13"
          },
          {
              title: "Higher Secondary",
              subtitle: "2016 - 2018",
              institution: "IJM HSS KOTTIYOOR",
              description: "Completed High School Education.\n\nSecuring 96.3%."
          }
      ],
      experience: [
          {
              title: "Backend Developer",
              subtitle: "2022",
              institution: "Student Management System",
              details: [
                  "Created database framework using Django and postgres sql.",
                  "Also high security authentication and authorisation was imeplemented in the website."
              ]
          },
          {
              title: "Frontend Developer",
              subtitle: "2020",
              institution: "Meez General Trading Ltd",
              details: [
                  "Product: A Trading Company's Website.,",
                  "Backend: React Js",
                  "Frontend: HTML , CSS , REACT",
                  "Created the product inserting engine from scratch using the React framework\ncordinated with lead team ."
              ]
          }
      ]
  };

  const data = (resumeData.summary.length || resumeData.education.length || resumeData.experience.length) ? resumeData : defaultData;

  return (
    <>
   <section id="resume" className="resume">
      <div className="container">

        <div className="section-title">
          <h2>Resume</h2>
          <p>To succeed in an environment of growth and excellence to earn a job which provides me job satisfaction and self-development and help me achieve personal as well as an organizational goal. Also to obtain a responsible, challenging and awarding position in a software development organization with an established track record where my skills, ability and technical ability can be utilized.</p>
          {resumeUrl && (
            <div className="mt-4 text-center text-lg-start">
                <a href={resumeUrl} target="_blank" rel="noopener noreferrer" className="btn btn-primary rounded-pill px-4 py-2 shadow-sm">
                    <i className="bi bi-file-earmark-pdf me-2"></i> Download Resume
                </a>
            </div>
          )}
        </div>

        <div className="row">
          <div className="col-lg-6" data-aos="fade-up">
            <h3 className="resume-title">Summary</h3>
            {loading ? (
              <div className="resume-item pb-0">
                <Skeleton height="24px" width="50%" style={{ marginBottom: '10px' }} />
                <Skeleton count={3} />
              </div>
            ) : (
              data.summary.map((item, index) => (
                <div className="resume-item pb-0" key={index}>
                <h4>{item.title}</h4>
                <p><em>{item.description}</em></p>
                <ul>
                    {item.contact_info && Object.values(item.contact_info).map((info, i) => (
                        <li key={i}>{info}</li>
                    ))}
                </ul>
                </div>
              ))
            )}

            <h3 className="resume-title">Education</h3>
            {loading ? (
               <>
                 <div className="resume-item">
                   <Skeleton height="24px" width="60%" style={{ marginBottom: '10px' }} />
                   <Skeleton height="20px" width="30%" style={{ marginBottom: '10px' }} />
                   <Skeleton count={2} />
                 </div>
                 <div className="resume-item">
                   <Skeleton height="24px" width="60%" style={{ marginBottom: '10px' }} />
                   <Skeleton height="20px" width="30%" style={{ marginBottom: '10px' }} />
                   <Skeleton count={2} />
                 </div>
               </>
            ) : (
              data.education.map((item, index) => (
                <div className="resume-item" key={index}>
                <h4>{item.title}</h4>
                <h5>{item.subtitle}</h5>
                <p><em>{item.institution}</em></p>
                <p style={{whiteSpace: 'pre-line'}}>{item.description}</p>
                </div>
              ))
            )}
          </div>
          <div className="col-lg-6" data-aos="fade-up" data-aos-delay="100">
            <h3 className="resume-title">Professional Experience</h3>
            {loading ? (
               <>
                 <div className="resume-item">
                   <Skeleton height="24px" width="70%" style={{ marginBottom: '10px' }} />
                   <Skeleton height="20px" width="30%" style={{ marginBottom: '10px' }} />
                   <Skeleton count={4} />
                 </div>
                 <div className="resume-item">
                   <Skeleton height="24px" width="70%" style={{ marginBottom: '10px' }} />
                   <Skeleton height="20px" width="30%" style={{ marginBottom: '10px' }} />
                   <Skeleton count={4} />
                 </div>
               </>
            ) : (
              data.experience.map((item, index) => (
                <div className="resume-item" key={index}>
                <h4>{item.title}</h4>
                <h5>{item.subtitle}</h5>
                <p><em>{item.institution}</em></p>
                <ul>
                    {item.details && (Array.isArray(item.details) ? item.details : JSON.parse(item.details || '[]')).map((detail, i) => (
                        <li key={i}>{detail}</li>
                    ))}
                </ul>
                </div>
              ))
            )}
          </div>
        </div>

      </div>
    </section>
    </>
  );
}

export default Resume;